export default __webpack_public_path__ + "images/map_europe.svg";